/**
 * Basis of the wet-bulb values `fetchNoaaClimateNormals` stores as
 * `designWetBulb` / `peakDesignWetBulb`. Those persisted field names are
 * legacy: the values are NOT design conditions.
 *
 * The NCEI 1991-2020 monthly normals dataset has no humidity, dew-point or
 * wet-bulb element; `MLY-TAVG-NORMAL` is the long-term average of monthly
 * average temperature (NCEI, Normals_MLY_Documentation_1991-2020.pdf,
 * https://www.ncei.noaa.gov/data/normals-monthly/1991-2020/doc/). The fetcher
 * applies the Stull (2011) approximation to each month's mean temperature
 * normal at the assumed relative humidity below. The result is a monthly-mean
 * screening estimate. It is not an ASHRAE Handbook—Fundamentals Ch. 14
 * climatic design condition (0.4/1/2 % annual cumulative frequency of hourly
 * observations), an equipment design condition, or a duty guarantee.
 *
 * Kept outside `noaaNormalsFetch.ts` so `sedToText` can label stored values
 * without statically importing the lazily loaded fetcher.
 */

/**
 * Relative humidity (%) assumed for every month. No NOAA or ASHRAE source for
 * this default has been identified; it is a screening assumption. It has been
 * 70 since the fetcher was introduced (46bde9fd9). `sedToText` labels
 * previously persisted values with it, so changing it requires persisting the
 * assumption on the SED record first.
 */
export const NOAA_NORMALS_ASSUMED_RH_PCT = 70;
